import { PasswordInput, required, useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import ShowIcon from '@/assets/icons/show-icon.svg?react';
import HideIcon from '@/assets/icons/hide-icon.svg?react';
import { Palette } from '@/themes/themeOverrides/Palette';

const CustomLoginPasswordInput = ({ isRequired = false, error, disableAutoComplete = false, ...props }) => {
    const translate = useTranslate();
    const [showPassword, setShowPassword] = useState(false);
    const [showError, setShowError] = useState(!!error);

    useEffect(() => {
        setShowError(!!error);
    }, [error]);

    const validatePassword = value => {
        const validationError = isRequired ? required()(value) : undefined;

        if (error) {
            setShowError(true);
            return undefined;
        }
        if (validationError) {
            setShowError(true);
            return validationError;
        }

        setShowError(false);
        return undefined;
    };

    return (
        <PasswordInput
            {...props}
            validate={validatePassword}
            helperText={translate('auth.invalidPassword')}
            sx={{
                marginTop: '18px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: showError ? `${Palette.red.red400} !important` : 'initial',
                },
                '& .MuiFormLabel-root': {
                    color: showError ? `${Palette.red.red400} !important` : 'initial',
                },
                '& .MuiFormHelperText-root': {
                    color: `${Palette.red.red800}`,
                    display: error ? 'block' : 'none',
                    background: Palette.red.red50,
                    margin: '4px 0 0',
                    padding: '8px',
                    borderRadius: '12px',
                    fontSize: '11px',
                },
                '& .MuiInputAdornment-root': {
                    position: 'absolute',
                    right: '16px',
                    top: '8px',
                    zIndex: 1,
                },
                '& .MuiInputLabel-root.MuiFormLabel-filled': {
                    transform: 'translate(14px, -11px) scale(1)',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                    transform: 'translate(14px, -11px) scale(1)',
                },
            }}
            InputProps={{
                type: showPassword ? 'text' : 'password',
                endAdornment: (
                    <InputAdornment position='end' sx={{ backgroundColor: 'transparent', marginRight: '4px' }}>
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge='end' sx={{ backgroundColor: 'transparent' }}>
                            {showPassword ? <ShowIcon /> : <HideIcon />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            autoComplete={disableAutoComplete ? 'new-password' : undefined}
            inputProps={disableAutoComplete ? { autoComplete: 'new-password' } : undefined}
        />
    );
};

export default CustomLoginPasswordInput;

CustomLoginPasswordInput.propTypes = {
    isRequired: PropTypes.bool,
    error: PropTypes.bool,
    disableAutoComplete: PropTypes.bool,
};
